import classNames from 'classnames';
import BeatLoader from 'components/animations/Loaders/BeatLoader';
import BaseLandaFinancingSection from 'pages/lend/components/BaseComponents/BaseLandaFinancingSection';
import BaseLandaFinancingShowAll from 'pages/lend/components/BaseComponents/BaseLandaFinancingShowAll';
import LandaFinancingActivityModal from 'pages/lend/components/LandaFinancingActivity/components/LandaFinancingActivityModal';
import useFinancingActivityPreviewFetcher from 'pages/lend/components/LandaFinancingActivity/hooks/useFinancingActivityPreviewFetcher';
import React, { useState } from 'react';
import { DebtType } from 'types/debt-types';
import { parseMoney } from 'utils/money_utils';
import LandaFinancingActivityRow from './components/LandaFinancingActivityRow';
import classes from './index.module.scss';
import { FinancialActivityType } from './types';

const LandaFinancingActivity = ({ debt }: { debt: DebtType }) => {
  const cash = debt.utilization[debt.utilization.length - 1].cashAmount;
  const { data, loading } = useFinancingActivityPreviewFetcher();
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <BaseLandaFinancingSection
      className={classes.container}
      title={'Activity'}
      rightComponent={
        <BaseLandaFinancingShowAll
          text={'Show All'}
          onClick={() => setModalOpen(true)}
        />
      }
      subtitle={parseMoney(cash)}
      subsubtitle={'Cash Balance'}
    >
      {loading ? (
        <BeatLoader className={classes.loader} />
      ) : (
        <div className={classNames(classes.list, data && classes.listTop)}>
          {data?.map((item: FinancialActivityType) => (
            <LandaFinancingActivityRow
              item={item}
              key={item.id}
            />
          ))}
        </div>
      )}
      <LandaFinancingActivityModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </BaseLandaFinancingSection>
  );
};

export default LandaFinancingActivity;
